<template>
  <!-- <swiper :options="swiperOption" ref="mySwiper"> -->
  <!-- slides -->
  <!-- <swiper-slide>
      <router-link to="/yunqi">
        <img v-show="language=='ch'"  class="swiper-wrapper-img" src="../../assets/coupon/image/05.jpg">
        <img v-show="language=='en'"  class="swiper-wrapper-img" src="../../assets/coupon/image/07.jpg">
      </router-link>
    </swiper-slide> -->
  <!-- <swiper-slide>
      <img v-show="language=='en'" class="swiper-wrapper-img" src="~assets/main-page/home_banner_2@3x.jpg">
      <img v-show="language=='ch'" class="swiper-wrapper-img" src="~assets/ch-image/main-page/home_banner_2@3x.jpg">
    </swiper-slide>
    <swiper-slide>
      <img class="swiper-wrapper-img" src="~assets/main-page/home_banner_3@3x.jpg">
    </swiper-slide>
    <swiper-slide>
      <img class="swiper-wrapper-img" src="~assets/main-page/home_banner_1@3x.jpg">
    </swiper-slide> -->
  <!-- Optional controls -->
  <!-- <div class="swiper-pagination" slot="pagination"></div>
  </swiper> -->

  <div class="swiper">
    <swiper :option="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper-wrapper-img b1">
          <p class="t1 top">OCEANBLUECLOUD</p>
          <p class="t2">Make Connection Easy</p>
          <p class="t2">Make Business Agile</p>
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="swiper-wrapper-img b2">
          <p class="t1 top1">OCEANBLUECLOUD</p>
          <p class="t3 top1">High Performance</p>
          <p class="t3">Strong Security</p>
          <p class="t3">Flexible Deployment</p>
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="swiper-wrapper-img b3">OCEANBLUECLOUD</div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "carrousel",
  props: ["language"],
  data() {
    return {
      swiperOption: {
        // NotNextTick is a component's own property, and if notNextTick is set to true, the component will not instantiate the swiper through NextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
        // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        //          notNextTick: true,
        loop: true, // 必须在autoplay之前
        // swiper configs 所有的配置同swiper官方api配置
        autoplay: 2000,
        autoplayDisableOnInteraction: false,
        // direction : 'vertical',
        effect: "slide",

        //          grabCursor : true,
        setWrapperSize: true,
        autoHeight: true,
        // paginationType:"bullets",
        pagination: ".swiper-pagination",
        paginationClickable: true,

        // scrollbar:'.swiper-scrollbar',
        //          mousewheelControl : true,
        observeParents: true,
        // if you need use plugins in the swiper, you can config in here like this
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        // debugger: true,
        // swiper callbacks
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        // onTransitionStart(swiper){
        //   console.log(swiper)
        // },
        // more Swiper configs and callbacks...
        // ...
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  // you can find current swiper instance object like this, while the notNextTick property value must be true
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    // you can use current swiper instance object to do something(swiper methods)
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  },
};
</script>

<style lang="scss">
@function toRem($x) {
  @return $x / 37.5 * 1rem;
}

.main-page .banner .swiper-wrapper-img {
  display: inline-block;
  width: toRem(375);
  height: toRem(350);
}
.b1 {
  background-image: url("~assets/main-page/banner_1.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% auto;
  text-align: center;
  color: #fff;
}
.b2 {
  background-image: url("~assets/main-page/banner_2.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% auto;
  text-align: center;
  color: #fff;
}
.b3 {
  background-image: url("~assets/main-page/banner_3.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% auto;
  text-align: center;
  color: #fff;
  line-height: toRem(350);
  font-size: toRem(30);
  color: #fff;
  font-weight: bold;
}
.top {
  margin-top: toRem(100);
}
.top1 {
  margin-top: toRem(70);
}
.t1 {
  font-size: toRem(30);
  margin-bottom: toRem(20);
}
.t2 {
  font-size: toRem(18);
}
.t3 {
  line-height: toRem(30);
  font-size: toRem(18);
  text-align: right;
  padding-right: toRem(50);
}

.main-page .banner .swiper-pagination-bullet {
  background: transparent;
  border-radius: 50%;
  border: toRem(1) solid #fff;
  opacity: 0.9;
  width: toRem(10);
  height: toRem(10);
}

.main-page .banner .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
  opacity: 1;
}

.main-page .banner .swiper-container {
  width: toRem(375);
  overflow: hidden;
  height: toRem(350);
  margin: 0 auto;
}
.main-page .banner .swiper-wrapper {
  width: 300%;
}
.main-page .banner .swiper-slide {
  float: left;
}
</style>



// WEBPACK FOOTER //
// Swiper.vue?8304c650